import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    ESTIMATE_CPD_AVAILABILITY: (userIds, date) => ({ userIds, date }),
    API: {
      ESTIMATE_CPD_AVAILABILITY: apiResourceActionCreator('estimations')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/estimateCpdAvailability`, authToken, payload, action.admin.api.estimateCpdAvailability)

function* estimateCpdAvailability(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'estimateCpdAvailability',
  action: action,
  sagas: estimateCpdAvailability,
  reducers: {
    request: (state, action) => ({
      ...state,
      isEstimatingCpdAvailability: true
    }),
    success: (state, action) => {
      const result = action.payload.estimations
      const updatedUserIds = fp.map(
        fp.get('user.id')
      )(result)
      const cpdAvailabilityEstimations = state.cpdAvailabilityEstimations
      const updatedEstimations = fp.flow(
        fp.filter(
          ({ user }) => !fp.includes(user.id)(updatedUserIds)
        ),
        fp.concat(result)
      )(cpdAvailabilityEstimations)
      return ({
        ...state,
        isEstimatingCpdAvailability: false,
        cpdAvailabilityEstimations: updatedEstimations
      })
    },
    failed: (state, action) => ({
      ...state,
      isEstimatingCpdAvailability: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/estimateCpdAvailability.js